var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Select user access level")]),_c('aside',{staticClass:"menu"},[_c('ul',{staticClass:"menu-list"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }